/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactType
 */
export interface ContactType {
    /**
     * 
     * @type {number}
     * @memberof ContactType
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ContactType
     */
    type: string;
}

export function ContactTypeFromJSON(json: any): ContactType {
    return ContactTypeFromJSONTyped(json, false);
}

export function ContactTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
    };
}

export function ContactTypeToJSON(value?: ContactType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
    };
}


